<template>
  <div>

    <div style="background-color: #fff;margin: 0px 5px;" :style="{height:th+'px'}">
      <div style="width: 100%;overflow: hidden;">
        <div style="text-align: center;padding: 20px">当月服务项目占比</div>
        <div>
          <ve-pie v-if="chartData_goods.rows.length>0"  :data="chartData_goods" :settings="chartSettings_goods"></ve-pie>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: "Page",
  data() {
    return {

      showModal:false,
      showModalInfo:false,

      showModalElderly:false,

      serveOrderPrice:0,


      loading: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      userCode: '',
      elderlyName:'',
      serveCode:'',
      serveName:'',


      startEndTime:[],

      isDelete:0,
      delete_arr: [
        {value: 0, label: '全部订单'},
        {value: 1, label: '正常订单'},
        {value: 2, label: '已删除订单'},
      ],


      imgUrl: this.$imgUrl,
      th: this.$store.state.tableHeight-170,

      showSum:true,

      zoneValue: [],
      zoneCode: '',
      zoneProps: {
        emitPath: false,
        value: 'zoneCode',
        label: 'name',
        children: 'listZoneDTO'
      },

      arr_business:[],
      businessCode:'',

      chartSettings_goods:{
        //设置中文图例
        labelMap:{
          //date对应后台返回json数据的key，具体值根据接口字段来修改
          class:"项目分类",
          //total对应后台返回son数据的value，具体值根据接口字段来修改
          total:"销售占比"
        }
      },
      chartData_goods: {
        //这里的格式必须是对应上面后台接口的字段才能显示图例
        columns: ['class', 'total'],
        rows: []
      },




    }
  },
  components: {

  },
  created() {

  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val-170;
    },
  },
  methods: {

    init(userCode) {
      this.userCode = userCode;
      this.getList();


      let arr3 = [
        {'class':'家政','total':'203'},
        {'class':'助餐','total':'143'},
        {'class':'护理','total':'93'},
        {'class':'康复','total':'60'},
        {'class':'精神慰藉','total':'35'},
        {'class':'智能设备','total':'22'},
      ];
      //this.chartData_goods.rows = arr3;

    },

    getList() {

      var _this=this
      this.loading=true

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        userCode:this.userCode,
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "OrderBusinessGov/ListServeMonth",
        data: data
      }).then((response) => {

        this.loading = false;

        if (response.data.error === 0) {
          this.tableData = response.data.data.list;

          let arr = [];
          for(let i=0;i<this.tableData.length;i++){
            arr.push({'class':this.tableData[i].goodsName,'total':this.tableData[i].number});
          }
          this.chartData_goods.rows = arr;

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }

      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });

    },


  }
}
</script>


<style lang="scss" scoped>


</style>
